(function initUpsellGlobal(){
  if (window.__UPS_SETONCE__) return;        // evita binds duplicados
  window.__UPS_SETONCE__ = true;

  const TS = () => `&_ts=${Date.now()}`;

  async function refreshUpsell() {
    try {
      const upsellRoot = document.querySelector('#CartDrawer-Upsell');
      if (!upsellRoot) return;

      const cart = await fetch(`/cart.js?${TS()}`, {
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      }).then((r) => r.json());

      const idsInCart = new Set(cart.items.map((i) => Number(i.product_id)));

      upsellRoot.querySelectorAll('.upsell-card').forEach((card) => {
        const pid = Number(card.dataset.productId);
        if (idsInCart.has(pid)) card.remove();
        else card.hidden = false;
      });

      upsellRoot.style.display = upsellRoot.querySelector('.upsell-card') ? '' : 'none';
      upsellRoot.querySelectorAll('.upsell-card__add[disabled]').forEach((b) => (b.disabled = false));
    } catch (e) {
      console.warn('refreshUpsell falhou', e);
    }
  }

  async function updateCartDrawerItems() {
    try {
      const html = await fetch(`/cart?section_id=cart-drawer${TS()}`, { cache: 'no-store' }).then((r) => r.text());
      const temp = document.createElement('div');
      temp.innerHTML = html;

      const swap = (sel) => {
        const neu = temp.querySelector(sel);
        const cur = document.querySelector(sel);
        if (neu && cur) cur.replaceWith(neu);
      };

      swap('#CartDrawer-CartItems');
      swap('.drawer__footer');

      await refreshUpsell();
      wireRemoveRefresh();
      bindCarousel();
    } catch (e) {
      console.warn('updateCartDrawerItems falhou', e);
    }
  }

  // Captura clique mesmo após injeção do drawer
  function getAddBtnFromEvent(ev) {
    if (ev.composedPath) {
      for (const n of ev.composedPath()) {
        if (n && n.classList && n.classList.contains && n.classList.contains('upsell-card__add')) return n;
      }
    }
    return ev.target.closest ? ev.target.closest('.upsell-card__add') : null;
  }

  ['pointerdown','touchend','click'].forEach((evt) => {
    document.addEventListener(evt, async (ev) => {
      const btn = getAddBtnFromEvent(ev);
      if (!btn) return;

      const upsellRoot = btn.closest('#CartDrawer-Upsell');
      if (!upsellRoot) return;

      // Anti-duplo clique / múltiplos eventos da mesma interação
      if (btn.__adding) return;
      btn.__adding = true;

      ev.preventDefault();
      ev.stopPropagation();
      ev.stopImmediatePropagation && ev.stopImmediatePropagation();

      const card = btn.closest('.upsell-card');
      const variantId = btn.dataset.variantId && Number(btn.dataset.variantId);
      if (!variantId) {
        console.warn('Upsell sem variantId. Verifique selected_or_first_available_variant no Liquid.');
        btn.__adding = false;
        return;
      }

      try {
        btn.disabled = true;

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 6 }),
        });
        if (!res.ok) {
          console.error('Falha ao adicionar upsell', res.status);
        }

        // Remove card e atualiza itens/rodapé do drawer
        if (card) card.remove();
        await updateCartDrawerItems();
      } catch (e) {
        console.error('Upsell add error', e);
      } finally {
        btn.disabled = false;
        setTimeout(() => (btn.__adding = false), 0);
      }
    }, true); // captura ajuda contra handlers do tema
  });

  function wireRemoveRefresh() {
    document.querySelectorAll('.cart-remove-button button')
      .forEach((btn) => btn.addEventListener('click', () => setTimeout(updateCartDrawerItems, 250), { passive: true }));
  }

  function bindCarousel() {
    const root = document.querySelector('#CartDrawer-Upsell');
    if (!root) return;
    const track = root.querySelector('.upsell__track');
    const prev  = root.querySelector('.upsell__btn--prev');
    const next  = root.querySelector('.upsell__btn--next');
    const scrollByCards = (dir=1) => {
      const card = track?.querySelector('.upsell-card');
      const step = card ? card.getBoundingClientRect().width + 12 : 300;
      track?.scrollBy({ left: dir * step, behavior: 'smooth' });
    };
    prev?.addEventListener('click', () => scrollByCards(-1));
    next?.addEventListener('click', () => scrollByCards(1));
  }

  // Observa <cart-drawer> para reexecutar binds após injeções
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    const mo = new MutationObserver(() => {
      refreshUpsell();
      wireRemoveRefresh();
      bindCarousel();
    });
    mo.observe(drawer, { childList: true, subtree: true });

    // Refresca após animações de abrir
    drawer.addEventListener('transitionend', () => {
      refreshUpsell();
      bindCarousel();
      wireRemoveRefresh();
    });
  }

  // Primeira rodada (caso já exista no DOM)
  refreshUpsell();
  bindCarousel();
  wireRemoveRefresh();

  // Tema editor / recarregamentos de seção
  document.addEventListener('shopify:section:load', (e) => {
    if (e.detail?.sectionId && String(e.detail.sectionId).includes('cart-drawer')) {
      refreshUpsell();
      bindCarousel();
      wireRemoveRefresh();
    }
  });
})();
